import { render } from "./Onboarding.vue?vue&type=template&id=58928b38&scoped=true&ts=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"

import "./Onboarding.vue?vue&type=style&index=0&id=58928b38&scoped=true&lang=css"
import "./Onboarding.vue?vue&type=style&index=1&id=58928b38&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58928b38"]])

export default __exports__